import styled from 'styled-components';

export const OverallRatingContainer = styled.div`
  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 16px;
  }
`;

export const AverageRatingReviewsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    height: 20px;
    width: 20px;
  }

  span {
    font-weight: 600;
  }

  .separator {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #000;
  }
`;
